var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"icon-button",on:{"click":function($event){return _vm.$emit('click')}}},[_c('svg-icon',{attrs:{"icon":_vm.icon,"height":_vm.size,"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }